export default "__VITE_ASSET__Ck92S2e6__"